//#region ../schema-sql-parser/dist/parser/statement/index.js
var StatementType = {
	createTable: "create.table",
	createIndex: "create.index",
	alterTableAddUnique: "alter.table.add.unique",
	alterTableAddPrimaryKey: "alter.table.add.primaryKey",
	alterTableAddForeignKey: "alter.table.add.foreignKey",
	alterTableAddDefault: "alter.table.add.default",
	alterTableAlterColumnAutoIncrement: "alter.table.alter.column.autoIncrement",
	commentOnTable: "comment.on.table",
	commentOnColumn: "comment.on.column"
};
var SortType = {
	asc: "ASC",
	desc: "DESC"
};
var ReferentialAction = {
	noAction: "NO ACTION",
	restrict: "RESTRICT",
	cascade: "CASCADE",
	setNull: "SET NULL",
	setDefault: "SET DEFAULT"
};
//#endregion
export { ReferentialAction, SortType, StatementType };
